import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "./utils";
const variantStyles = {
    default: "bg-background border-border text-foreground",
    destructive: "bg-destructive/10 border-destructive text-destructive",
    success: "bg-green-50 border-green-500 text-green-800",
    warning: "bg-yellow-50 border-yellow-500 text-yellow-800",
};
export const Alert = forwardRef(({ className, variant = "default", ...props }, ref) => (_jsx("div", { ref: ref, role: "alert", className: cn("relative w-full rounded-lg border p-4", variantStyles[variant], className), ...props })));
Alert.displayName = "Alert";
//# sourceMappingURL=alert.js.map